<template>
    <v-layout :wrap="$vuetify.breakpoint.xsOnly" class="promo-items" align-center justify-space-between>
        <v-flex v-for="item in items" :key="item.id">
            <v-layout align-center justify-center class="pa-2">
                <div class="mr-2">
                    <img :src="item.icon" :alt="item.title" />
                </div>
                <div>
                    <strong class="text-uppercase">{{ item.title }}</strong>
                    <span>{{ item.subtitle }}</span>
                </div>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        name: 'Promo',
        data () {
            return {
                items: [
                    {id: 1, title: 'Věrnostní program', subtitle: 'Připravujeme', icon: require('../../assets/icons/loyalty.svg')},
                    {id: 2, title: 'Čerstvé suroviny', subtitle: 'U nás je vše čerstvé', icon: require('../../assets/icons/fresh.svg')},
                    {id: 3, title: 'Doručení zdarma', subtitle: 'V rámci Galerie Harfa', icon: require('../../assets/icons/delivery.svg')},
                    {id: 4, title: 'Doručení po Praze', subtitle: 'Přes Wolt', icon: require('../../assets/icons/wolt.svg')},
                    {id: 5, title: 'Doručení po Praze', subtitle: 'Přes Dáme jídlo', icon: require('../../assets/icons/damejidlo.png')}
                ]
            }
        },
    }
</script>

<style lang="scss">
    .promo-items {
        strong {
            display: block;
            font-size: 14px;
            font-weight: 600;
        }
        span {
            color: #777;
        }
        img {
            max-width: 60px;
            width: 100%;
        }
    }
</style>
